import type { AdminApiPlaybook } from "@repo/app-types/entities/playbook";
import { getOutcomeDefinitionFromPlaybook } from "@repo/app-types/entities/playbook";
import { useMemo } from "react";
import { usePerformanceMetricColumnSelector } from "./usePerformanceMetricColumnSelector.js";

interface UseCallsMetricColumnSelectorOptions {
  playbook: AdminApiPlaybook | undefined;
  isCustomerExperienceScoreEnabled: boolean;
}

export function useCallsMetricColumnSelector(
  options: UseCallsMetricColumnSelectorOptions,
) {
  const { playbook, isCustomerExperienceScoreEnabled } = options;
  const hasOutcome = getOutcomeDefinitionFromPlaybook(playbook) !== undefined;
  const availableOptions = useMemo(
    () => [
      ...(hasOutcome ? [{ id: "outcome", label: "Outcome" }] : []),
      ...(isCustomerExperienceScoreEnabled
        ? [{ id: "cxScore", label: "CX score" }]
        : []),
    ],
    [hasOutcome, isCustomerExperienceScoreEnabled],
  );

  return usePerformanceMetricColumnSelector({
    playbook,
    view: "calls",
    availableOptions,
  });
}
